var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnbIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.46,23.98c-1.87-0.81-3.03-2.34-3.03-3.98s1.16-3.17,3.03-3.99c0.4-0.18,0.62-0.62,0.5-1.04 c-0.84-3.01-2.44-5.78-4.62-8.01c-0.31-0.31-0.8-0.35-1.15-0.09c-1.64,1.22-3.54,1.46-4.97,0.63c-1.43-0.82-2.17-2.59-1.94-4.61 c0.05-0.44-0.23-0.84-0.66-0.95c-3.12-0.8-6.13-0.8-9.24,0c-0.43,0.11-0.71,0.52-0.66,0.95c0.23,2.02-0.51,3.79-1.94,4.61 c-1.43,0.82-3.33,0.58-4.97-0.63C7.46,6.61,6.97,6.65,6.66,6.96c-2.18,2.23-3.78,5-4.62,8.01c-0.12,0.42,0.09,0.87,0.5,1.04 c1.87,0.81,3.03,2.34,3.03,3.99s-1.16,3.17-3.03,3.98c-0.4,0.18-0.62,0.62-0.5,1.04c0.84,3.01,2.44,5.78,4.62,8.01 c0.31,0.31,0.8,0.35,1.15,0.09c1.64-1.21,3.54-1.46,4.97-0.63c1.43,0.82,2.17,2.59,1.94,4.61c-0.05,0.44,0.23,0.84,0.66,0.95 c1.56,0.4,3.11,0.6,4.62,0.6c1.51,0,3.06-0.2,4.62-0.6c0.43-0.11,0.71-0.52,0.66-0.95c-0.23-2.02,0.51-3.79,1.94-4.61 c1.43-0.82,3.33-0.58,4.97,0.63c0.35,0.26,0.84,0.22,1.15-0.09c2.18-2.23,3.78-5,4.62-8.01C38.07,24.6,37.86,24.16,37.46,23.98z  M20,26.42c-3.55,0-6.42-2.87-6.42-6.42s2.87-6.42,6.42-6.42s6.42,2.87,6.42,6.42S23.55,26.42,20,26.42z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIcon3);
export default __webpack_public_path__ + "static/media/gnb_icon_3.1092635f3e4605e10f48dc428c851db0.svg";
export { ForwardRef as ReactComponent };